/* unplugin-vue-components disabled *//* vant-demand-import */
import installComponents from "!../../../plugins/vant-demand-import/installComponents.js"
import VanButton from 'vant/es/button'
import 'vant/es/button/style/less'
import '/Users/noromacpro/work/orale-h5/vant-extra/style-override/button.css'
import VanCountDown from 'vant/es/count-down'
import 'vant/es/count-down/style/less'
import VanField from 'vant/es/field'
import 'vant/es/field/style/less'
import VanForm from 'vant/es/form'
import 'vant/es/form/style/less'


import { render, staticRenderFns } from "./close-account.vue.js?vue&type=template&id=4e91fed7!=!../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./close-account.vue?vue&type=template&id=4e91fed7"
import script from "./close-account.vue.ts?vue&type=script&setup=true&lang=ts!=!../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./close-account.vue?vue&type=script&setup=true&lang=ts"
export * from "./close-account.vue.ts?vue&type=script&setup=true&lang=ts!=!../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./close-account.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./close-account.vue.postcss?vue&type=style&index=0&id=4e91fed7&prod&lang=postcss&module=true!=!../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./close-account.vue?vue&type=style&index=0&id=4e91fed7&prod&lang=postcss&module=true"




function injectStyles (context) {
  
  this["$style"] = (style0.locals || style0)

}

/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  null
  
)

export default component.exports
installComponents(component, {VanButton,VanCountDown,VanField,VanForm})
